import { DropdownOptions } from '@components/common/formControl/dropdown';
import { FormikValues } from 'formik';

export interface IdefaultAddSiteLeadFormInitialValues {
	siteType: string;
	dealerName: string;
	gluePotentialOfSite: string | null;
	owner_details: TAccordianDetails[];
	architect_details: TAccordianDetails[];
	demoedProducts?: string | null;
	discussedProducts?: string | null;
	availableProducts: DropdownOptions[];
	demoedProductDetails: TProductDetails[];
	discussedProductDetails: TProductDetails[];
	productImages: File[];
	veneer: string | null;
	isContractorAvailable: string | null;
	fvGlueUsedSoFar: string | null;
	competitionGlueUsedSoFar: string | null;
	noOfActiveSites: string | null;
	role?: string;
	availableOtherProductsDemoed: DropdownOptions[];
	availableOtherProductsDiscussed: DropdownOptions[];
	productComplaintLast1Month?: string | null;
	productComplaintDescription: DropdownOptions[];
	complaintProductsList: DropdownOptions[];
	customProductComplaintDescription?: string | null;
	isWeatherWorkGivenToJoinery: string | null;
	joineryName: string | null;
	joineryNumber: string | null;
	joineryAddress: string | null;
	isWorkGivenToFactory: string | null;
	factoryName: string | null;
	factoryNumber: string | null;
	factoryAddress: string | null;
}

export const defaultSiteAddressFormInitialValues: IdefaultAddSiteLeadFormInitialValues = {
	siteType: 'Residential',
	dealerName: '',
	gluePotentialOfSite: '',
	architect_details: [{ id: 0, isActive: true, name: '', number: '' }],
	owner_details: [{ id: 0, isActive: true, name: '', number: '' }],
	demoedProducts: '',
	discussedProducts: '',
	availableProducts: [],
	demoedProductDetails: [{ id: 0, product: null }],
	discussedProductDetails: [{ id: 0, product: null }],
	productImages: [],
	veneer: '',
	isContractorAvailable: '',
	fvGlueUsedSoFar: null,
	competitionGlueUsedSoFar: null,
	noOfActiveSites: null,
	role: '',
	availableOtherProductsDemoed: [],
	availableOtherProductsDiscussed: [],
	productComplaintLast1Month: '',
	productComplaintDescription: [],
	complaintProductsList: [],
	customProductComplaintDescription: '',
	isWeatherWorkGivenToJoinery: '',
	joineryName: '',
	joineryNumber: '',
	joineryAddress: '',
	isWorkGivenToFactory: '',
	factoryName: '',
	factoryNumber: '',
	factoryAddress: '',
};

export type TAccordianDetails = {
	id: number;
	name: string;
	number: string;
	isActive: boolean;
	avg_monthly_tile_adhesive_consumption?: number;
	address?: string;
};

export type TProductDetails = {
	id: number;
	product: string | null;
};

export interface IDemoedProductProps {
	formik: TFormik;
	productIndex: number;
	fieldName: string;
}

export interface IDiscussedProductsProps {
	formik: TFormik;
	productIndex: number;
	fieldName: string;
}

export type TFormik = {
	values: FormikValues;
	setFieldValue: (field: string, value: string | string[] | boolean, shouldValidate?: boolean) => void;
	touched: FormikValues;
	errors: FormikValues;
	handleBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
};

export interface IProductImagesProps {
	fieldName: string;
	formik: TFormik;
	handleAddImage: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export interface IRemoveImageProps {
	fieldName: string;
	formik: TFormik;
	imgIndex: number;
}

export const veneerOptions: DropdownOptions[] = [
	{ id: 1, value: 'Yes' },
	{ id: 2, value: 'No' },
];

export const productComplaintOptions: DropdownOptions[] = [
	{ id: 1, value: 'Yes' },
	{ id: 2, value: 'No' },
];

export const productComplaintDescriptionOptions: DropdownOptions[] = [
	{ id: 1, value: 'Bubble Formation' },
	{ id: 2, value: 'Debonding' },
	{ id: 3, value: 'Laminate / Mica Cracking' },
	{ id: 4, value: 'Not Drying' },
	{ id: 5, value: 'Others' },
];
